import { FaCar, FaDollarSign, FaMapMarkedAlt, FaClock } from 'react-icons/fa';

const whyChooseUs = {
    sub: "Why Choose Us",
    heading: "Reliable Car Rental Service",
    content: "At QuickRide Car Rentals, we offer affordable, well-maintained vehicles with flexible rental options to suit your travel needs.",
    points: [
        {
            id: 1,
            title: 'Wide Vehicle Selection',
            icon: <FaCar />,
        },
        {
            id: 2,
            title: 'Affordable Rates',
            icon: <FaDollarSign />,
        },
        {
            id: 3,
            title: 'Convenient Locations',
            icon: <FaMapMarkedAlt />,
        },
        {
            id: 4,
            title: 'Flexible Rentals',
            icon: <FaClock />,
        },
    ]
};

export default whyChooseUs;